import { createContext } from 'react';
import { ClientSideConfig } from 'types';

export const initialConfigContextState: ClientSideConfig = null;

export const ConfigContext = createContext<ClientSideConfig>(initialConfigContextState);